/**
 * Notification API Service
 */

import apiClient from './apiClient';
import { NotificationDTO } from '../types/notification.types';

const BASE_PATH = '/v1/notifications';

class NotificationService {
  async getUserNotifications(userId: string): Promise<NotificationDTO[]> {
    const response = await apiClient.get<NotificationDTO[]>(`${BASE_PATH}/user/${userId}`);
    return response.data;
  }

  async getUnreadNotifications(userId: string): Promise<NotificationDTO[]> {
    const response = await apiClient.get<NotificationDTO[]>(`${BASE_PATH}/user/${userId}/unread`);
    return response.data;
  }

  async getUnreadNotificationCount(userId: string): Promise<number> {
    const response = await apiClient.get<number>(`${BASE_PATH}/user/${userId}/unread-count`);
    return response.data;
  }

  async markAsRead(notificationId: string): Promise<void> {
    await apiClient.patch(`${BASE_PATH}/${notificationId}/read`);
  }

  async markAllAsRead(userId: string): Promise<void> {
    await apiClient.patch(`${BASE_PATH}/user/${userId}/read-all`);
  }
}

export default new NotificationService();
